/* LEGAL ENTITY DATA */
export const GET_LEGAL_ENTITY_LIST = "GET_LEGAL_ENTITY_LIST";
export const SET_LEGAL_ENTITY_LIST = "SET_LEGAL_ENTITY_LIST";
export const ADD_LEGAL_ENTITY = "ADD_LEGAL_ENTITY";

/* LEGAL ENTITY ACTIONS */
export const DELETE_LEGAL_ENTITY = "DELETE_LEGAL_ENTITY";

/* LEGAL ENTITY DATA PROFILE */
export const GET_LEGAL_ENTITY_PROFILE = "GET_LEGAL_ENTITY_PROFILE";
export const SET_LEGAL_ENTITY_PROFILE = "SET_LEGAL_ENTITY_PROFILE";
export const UPDATE_LEGAL_ENTITY_PROFILE = "UPDATE_LEGAL_ENTITY_PROFILE";
export const SET_ERROR_LEGAL_ENTITY_PROFILE = "SET_ERROR_LEGAL_ENTITY_PROFILE";

/* LOADER */
export const SHOW_LEGAL_ENTITY_LIST_LOADER = "SHOW_LEGAL_ENTITY_LIST_LOADER";
export const HIDE_LEGAL_ENTITY_LIST_LOADER = "HIDE_LEGAL_ENTITY_LIST_LOADER";
export const LEGAL_ENTITY_PROFILE_LOADER = "LEGAL_ENTITY_PROFILE_LOADER";
